import React,{useState} from 'react';
// import { useHistory } from 'react-router-dom';
import Button from 'components/Button';
import CloseIcon from 'assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Container } from "styles/components/CommentBoxModal";
import { useText } from 'locales/useGetText';
// import  "./commentBoxModal.css"


const CommentBoxModal = ({ isOpen, toggle, title, content, link, onClickHander,type }) => {
  // let history = useHistory();
  const locale = useText("commonModals");

  const redirectLink = (link) => {
    if (link === 'manageAccount') {
      window.location.reload(false);
    } else {
      if (link !== '/') {
        // history.push(link);
      }
    }
    toggle(!isOpen)
  }

  const [message, setMessage] = useState('')
  const sendMessage = async (e) => {
    
  }
  return (
    // <Container>
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        // className='next-step-modal'
        >
        <Container>
          <div className='modal-content'>
            <div className='header'>
              <Button handleClick={() => {
                if (link === 'manageAccount') {
                  window.location.reload(false);
                }
                setMessage("")
                onClickHander('no')
                toggle(!isOpen)
              }}>
                <img src={CloseIcon} className="closeIcon" alt="close-icon" />
              </Button>
              {/* className='modal-title' */}
              <h3 style={{"text-align": "left"}}>{content}</h3>
            </div>
            <ModalBody>
              {/* <div>
                <h3 className='modal-title' style={{"text-align": "left"}}>{content}</h3>
              </div> */}
              <div className='modal-content'>
                <h5 style={{"text-align": "left"}}>{locale('addComment')}<span className="star">&#42;</span></h5>
              <textarea placeholder={locale('typeComment')} name="comment" style={{"min-height":"100px", "margin-bottom":"10px"}} required value={message}
                  onChange={e => setMessage(e.target.value)}
                ></textarea>
                {/* {type === 'inventory' ?
                  <h5>{content}</h5>
                  :
                <h6 className='my-2 mb-4'>{content}</h6>
                } */}
              </div>
            </ModalBody>
            <ModalFooter className='modal-footer'>
              <Button
                type='app-green-button submitBtn'
                handleClick={() => {
                  toggle(!isOpen)
                  setMessage("")
                  onClickHander('no')
                }}>
                {locale('noButton')}
              </Button>
              <Button
                type='app-green-button'
                disabled={message?false:true}
                handleClick={() => {
                  toggle(!isOpen)
                  onClickHander(message)
                  setMessage("")
                }}>
                {locale('yesButton')}
              </Button>

            </ModalFooter>
          </div>
        </Container>  
      </Modal>
    </div>
    // </Container>
  );
};
export default CommentBoxModal;
